import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { components } from 'react-select';
import Hint from '../../Hint/Hint.js';

const Control = (_a) => {
    var { selectProps, children } = _a, rest = __rest(_a, ["selectProps", "children"]);
    const { isDisabled, hint, hintDuration, startComponent: StartComponent } = selectProps;
    return (jsx(Hint, Object.assign({ title: hint, duration: hintDuration }, { children: jsx("span", Object.assign({ "aria-disabled": isDisabled, "data-testid": selectProps['data-testid'] }, { children: jsxs(components.Control, Object.assign({ selectProps: selectProps }, rest, { children: [StartComponent && jsx(StartComponent, {}), children] })) })) })));
};

export { Control as default };
//# sourceMappingURL=Control.js.map
